<template>
  <div class="main-right">
    <div class="header">指数分布</div>
    <div class="block-body">
      <div class="body-top">
        <p class="body-title">{{ title }}发展指数分布图</p>
        <div class="map">
          <div id="container" style="height: 100%"></div>
        </div>
      </div>
      <div class="body-bottom">
        <p class="body-title">{{ title }}发展指数排名</p>
        <div class="table">
          <div class="body-h">
            <div class="rank">排名</div>
            <div class="region">地区</div>
            <div class="sort">指数</div>
          </div>
          <vue-scroll :ops="ops" style="height: 100%">
            <div class="item" v-for="(item, key) in rankList">
              <div class="num" :class="{ first: key == 0, second: key == 1, third: key == 2 }">
                {{ key + 1 }}
              </div>
              <div class="city" @click="setCity(item)">
                {{ item.region_name_zh }}
              </div>
              <div class="val">{{ item.val }}</div>
              <div class="bar-box">
                <div class="bar">
                  <div class="inner-bar" :style="{ width: `${item.percent}%` }"></div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/until/configs";
import AMapLoader from "@amap/amap-jsapi-loader";

// 高德地图 2.0 安全密钥兜底（main.js 已设置，这里再保一次，防止单页跳入时未设置）
if (!window._AMapSecurityConfig) {
  window._AMapSecurityConfig = {
    securityJsCode: "a6c95f2d49553768ccd84ab100783147",
  };
}
var district;
export default {
  props: ["year", "cubeId", "tag", 'title'],
  data() {
    return {
      AMap: null,
      rankList: [],
      ops: config.vueScrollSetting,
      polygons: [],
      status: false
    };
  },
  mounted() {
    this.initMap();
  },

  methods: {
    addPolygon(path) {
      let polygon = new this.AMap.Polygon({
        path: path,
        fillColor: "#ccebc5",
        strokeOpacity: 1,
        fillOpacity: 0.5,
        strokeColor: "#2b8cbe",
        strokeWeight: 1,
        strokeStyle: "dashed",
        strokeDasharray: [5, 5],
      });
      polygon.on("mouseover", () => {
        polygon.setOptions({
          fillOpacity: 0.7,
          fillColor: "#7bccc4",
        });
      });
      polygon.on("mouseout", () => {
        polygon.setOptions({
          fillOpacity: 0.5,
          fillColor: "#ccebc5",
        });
      });
      this.map.add(polygon);
      this.polygons.push(polygon)
    },
    setCity(city) {
      const position = new this.AMap.LngLat(city.longitude, city.latitude);
      this.map.setCenter(position);
      this.map.setZoom(10);
    },
    districtArea() {
      this.$emit('setLoading', true)
      const city = this.rankList[0];
      const position = new this.AMap.LngLat(city.longitude, city.latitude);
      this.map.setCenter(position);
      this.map.setZoom(6);
      this.polygons = [];

      this.searchDistricts(this.rankList, 0, this.cubeId)
      // this.rankList.forEach(async (item) => {
      //   console.log(1111, item.region_code, item.region_name_en)
      //   district.search(item.region_code, (status, result) => {
      //     console.log(2222, item.region_code, item.region_name_en, result.districtList)
      //     const boundary = result.districtList[0].boundaries;

      // if (boundary) {
      //   for (let i = 0; i < boundary.length; i++) {
      //     boundary[i] = [boundary[i]]
      //   }
      //   this.addPolygon(boundary);
      // }
      //   });

      // });
    },
    async searchDistricts(list, index = 0, cubeId) {
      const that = this
      // 终止条件：所有地址检索完成
      if (index >= list.length) {
        console.log('所有地址检索完成');
        this.$emit('setLoading', false)
        return;
      }
      // if (this.status && cubeId != this.cubeId) {
      //   this.polygons=[]
      //   this.map.clearMap()
      //   return
      // }
      const currentAddress = list[index];
      try {
        // 用Promise包装异步接口，实现串行执行
        const boundary = await new Promise((resolve, reject) => {
          district.search(currentAddress.region_code, (status, info) => {
            if (status === 'complete' && info.info === 'OK') {
              resolve(info.districtList[0].boundaries);
            } else {
              reject(new Error(`检索${currentAddress}失败：${info.info || status}`));
            }
          });
        });

        if (boundary) {
          for (let i = 0; i < boundary.length; i++) {
            boundary[i] = [boundary[i]]
          }
          that.addPolygon(boundary);
          that.map.setFitView(this.polygons, false, [10, 10, 10, 10])
        }
        console.log(`第${index + 1}个地址检索成功：`, currentAddress);

        // 延迟执行下一个（避免请求过快被限流，可根据实际调整）
        setTimeout(() => {
          that.searchDistricts(list, index + 1, cubeId);
        }, 250);

      } catch (error) {
        console.error(error.message);
        // 即使当前地址失败，也继续执行下一个
        setTimeout(() => {
          that.searchDistricts(list, index + 1, cubeId);
        }, 250);
      }
    },
    getRankList() {
      const params = {
        cubeId: this.cubeId,
        years: this.year,
        indicatorCode: "01",
      };
      this.$http.getIndicatorTop(params).then((res) => {
        if (res.success) {
          res.list.map((item) => {
            item.percent = (item.val / res.list[0].val) * 100;
            return item;
          });
          this.rankList = res.list;
          if (district) {
            this.map.clearMap();
            this.districtArea();
          }
        } else {
          this.$emit('setLoading', false)
        }
      }).catch((e) => {
        this.$emit('setLoading', false)
      });
    },
    initMap() {
      AMapLoader.load({
        key: "e39037764d5c2ca2e2fc07a5c3505bc7", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.Scale",
          "AMap.ToolBar",
          "AMap.PolygonEditor",
          "AMap.Marker",
          "AMap.PlaceSearch",
          "AMap.DistrictSearch",
        ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.AMap = AMap;
          this.map = new AMap.Map("container", {
            //设置地图容器id
            zoom: 8, //初始化地图级别
            center: [116.602725, 40.076636], //初始化地图中心点位置
          });

          //比例尺
          let scale = new AMap.Scale({
            position: {
              bottom: "10px",
              right: "50px",
            },
          });
          //放大缩小工具
          let toolBar = new AMap.ToolBar({
            visible: true,
            position: {
              bottom: "10px",
              right: "10px",
            },
          });
          //行政信息
          let opts = {
            subdistrict: 0, //获取边界不需要返回下级行政区
            extensions: "all", //返回行政区边界坐标组等具体信息
            showbiz: false,
            level: "city", //查询行政级别为 市
          };
          district = new AMap.DistrictSearch(opts);

          this.map.clearMap();
          this.districtArea();
          this.map.addControl(scale);
          this.map.addControl(toolBar);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  watch: {
    year(val) {
      this.getRankList();
    },
    cubeId(val) {
      this.status = true
      this.getRankList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/dataIndex/index.scss";
</style>
